import { Button, Col, Form, Input, Modal, Row, Space } from "antd";
import React, { useCallback, useState } from "react";
import { AiOutlineClear, AiOutlineSearch } from "react-icons/ai";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useUserContextHook } from "../../../hooks/useUserContextHook";
import { IBookingState } from "../../../model/BookingModel";
import { ICNDNWaybill } from "../../../model/CNDNModel";
import { useBookingStore } from "../../../stores/BookingStore";
import { useCNDNStore } from "../../../stores/CNDNStore";
import { convertDateIntoMillis } from "../../../utils/luxon";
import { requiredValidation } from '../../../validation/validation';
import Hook from "../Hook";
import CreateCreditNoteTableComponent from "./CreateCreditNoteTableComponent";

const FetchFromOracle = ({ open, setOpen }: { open: boolean, setOpen: (open: boolean) => void }) => {
    const [form] = Form.useForm();
    const fetchFromOracleAction = useCNDNStore((state) => state?.FetchFromOracleAction);
    const { promiseInProgress: fetchFromOraclePromise } = usePromiseTracker({ area: "fetch-from-oracle-area" });

    const handleClose = useCallback(() => {
        form.setFieldValue("waybillNo", "");
        setOpen(false);
    }, [setOpen]);

    const handleSubmit = useCallback((values: any) => {
        trackPromise(
            fetchFromOracleAction(values?.waybillNo.trim(), handleClose), 
            "fetch-from-oracle-area" 
        );
    }, [fetchFromOracleAction, handleClose]);

    return (
        <Modal 
            title="Fetch From Oracle" 
            open={open} 
            onCancel={handleClose} 
            onOk={form.submit}
            okText="Fetch" 
            okButtonProps={{ disabled: fetchFromOraclePromise }} 
            maskClosable={false}
        >
            <Form form={form} onFinish={handleSubmit} autoComplete="off">
                <Row gutter={10} justify={"start"}>
                    <Col span={12}>
                        <Form.Item name="waybillNo" label="Waybill No" labelCol={{ span: 24 }} rules={[requiredValidation]}>
                            <Input />
                        </Form.Item>
                    </Col>   
                </Row>
            </Form>
        </Modal>
    );
};

const SearchComponent = () => {
    const [open, setOpen] = useState(false);

    const [form] = Form.useForm();
    const { promiseInProgress: CNSearchProgress } = usePromiseTracker({ area: 'cn-search-area' });

    const { onClearHandler } = Hook({ form });
    const GetCNDNWaybillSearchAction = useCNDNStore(state => state?.GetCNDNWaybillSearchAction);

    const onSearchHandler = (values: { subClientId: number, dateRange, oracleInvoiceNumber: number }) => {
        useCNDNStore.setState({ creditNoteResponse: {} });
        useCNDNStore.setState({ search: [] });
        const { subClientId, dateRange, oracleInvoiceNumber } = values || {};
        const request: ICNDNWaybill = {
            subClientId,
            startDate: convertDateIntoMillis(dateRange?.at(0)),
            endDate: convertDateIntoMillis(dateRange?.at(1)),
            oracleInvoiceNumber: Number(String(oracleInvoiceNumber)?.trim())
        };
        trackPromise(GetCNDNWaybillSearchAction(request), 'cn-search-area');
    };

    return (
        <>
            <Form form={form} onFinish={onSearchHandler} autoComplete="off">
                <Row gutter={10} justify={'start'} align={'middle'}>
                    <Col md={6} lg={4} xl={4} sm={8}>
                        <Form.Item name={'oracleInvoiceNumber'} label='Invoice number' labelCol={{ span: 24 }}
                            rules={[{ ...requiredValidation }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col className="margin-top-1rem">
                        <Space size={5} >
                            <Button className='icon-button' type='primary' htmlType='submit'
                                loading={CNSearchProgress}
                                size="middle"
                                icon={<AiOutlineSearch size={20} />} />
                            <Button className='icon-button' type='default'
                                size="middle"
                                htmlType='button' onClick={onClearHandler} icon={<AiOutlineClear size={20} />} />
                        </Space>
                    </Col>
                    <Col className="margin-top-1rem" flex={1}>
                        <Row justify="end" align={"middle"}>
                            <Col>
                                <Button type="default" size="middle" htmlType="button" onClick={() => setOpen(true)}>
                                    Fetch From Oracle
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
            {open ? <FetchFromOracle open={open} setOpen={(open) => setOpen(open)} /> : null}
        </>
    )
}
const CreditNoteCreateComponent = ({ open, onClose }: { open: boolean, onClose: (value: boolean) => void }) => {


    const { employeeDetail } = useUserContextHook() || {};
    const getCustomerAction = useBookingStore((state: IBookingState) => state?.GetCustomerByIdAction);

    React.useEffect(() => {
        trackPromise(getCustomerAction(employeeDetail?.employeeId), 'customer-area')
    }, [employeeDetail?.employeeId, getCustomerAction]);


    const onCancelHandler = () => {
        useCNDNStore.setState({ creditNoteResponse: {} });
        onClose(false)
    }
    return (
        <Modal open={open} onCancel={onCancelHandler} title='CN / DN Request' width={2000}
            okButtonProps={{ style: { display: 'none' } }} centered maskClosable={false}>
            <SearchComponent />
            <CreateCreditNoteTableComponent />
        </Modal>
    )
}
export default CreditNoteCreateComponent